import React, { useEffect, useState } from 'react';
import {
  getOfficeLocations,
  createOfficeLocation,
  updateOfficeLocation,
  deleteOfficeLocation,
} from '../services/officeLocation.service';
import OfficeLocationForm from '../components/OfficeLocationForm';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const OfficeLocationList: React.FC = () => {
  const [locations, setLocations] = useState<any[]>([]);
  const [selected, setSelected] = useState<any | null>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchLocations = () => {
    getOfficeLocations().then(res => setLocations(res.data));
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleCreate = () => {
    setSelected(null);
    setOpen(true);
  };

  const handleEdit = (location: any) => {
    setSelected(location);
    setOpen(true);
  };

  const handleDelete = (id: number) => {
    if (
      window.confirm('Are you sure you want to delete this office location?')
    ) {
      deleteOfficeLocation(id).then(fetchLocations);
    }
  };

  const handleSubmit = (data: any) => {
    setLoading(true);
    if (selected) {
      updateOfficeLocation(selected.id, data).then(() => {
        setOpen(false);
        setLoading(false);
        fetchLocations();
      });
    } else {
      createOfficeLocation(data).then(() => {
        setOpen(false);
        setLoading(false);
        fetchLocations();
      });
    }
  };

  return (
    <div>
      <Typography variant='h4' gutterBottom>
        Office Locations
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={handleCreate}
        sx={{ mb: 2 }}
      >
        Add Office Location
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>City</TableCell>
              <TableCell>State</TableCell>
              <TableCell>ZIP</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>Contact Person</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.map(loc => (
              <TableRow key={loc.id}>
                <TableCell>{loc.name}</TableCell>
                <TableCell>{loc.address}</TableCell>
                <TableCell>{loc.city}</TableCell>
                <TableCell>{loc.state}</TableCell>
                <TableCell>{loc.zip}</TableCell>
                <TableCell>{loc.country}</TableCell>
                <TableCell>{loc.contact_person}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(loc)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(loc.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          {selected ? 'Edit Office Location' : 'Add Office Location'}
        </DialogTitle>
        <DialogContent>
          <OfficeLocationForm
            initialValues={selected || {}}
            onSubmit={handleSubmit}
            loading={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OfficeLocationList;
